import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[60] origin-left pointer-events-none"
      style={{ scaleX }}
    >
      <div className="h-[3px] w-full bg-gradient-to-r from-[#e6c769] via-[#fff8d6] to-[#e6c769] shadow-[0_0_18px_rgba(230,199,105,0.7)]" />
    </motion.div>
  );
};

export default ScrollProgress;
